import { defineComponent } from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

export default defineComponent({
    name: 'basic-watcher-dsgn',
    mixins: [DesignerRegistryMixin],
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
        Name: function () {
            return this.controlData?.Name;
        }
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        type: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render(h) {
        let name;
        if (!this.Name)
            name = this.type;
        else
            name = this.Name + ': ' + 'Watcher';

        return (
            <div
                title={name}
                style={{ backgroundColor: "lightblue", color: "maroon" }}
                class={{ 'designer-container': true, selected: this.selected$ }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <i class="mdi mdi-eye"></i>
            </div>
        );
    }
});